export const loadedAction = (state, payload) => {
  return {
    ...state,
    loaded: payload
  };
};
